declare const RELEASE_VERSION: string | undefined;

/**
 * Returns the release version injected at build time by the nx-sdk esbuild
 * plugin (from the `RELEASE_VERSION` env var), or `undefined` when building
 * without one (e.g. local development). Used as the Sentry release.
 */
export const releaseVersion = (): string | undefined => {
  if (typeof RELEASE_VERSION === 'undefined') {
    return undefined;
  }

  return RELEASE_VERSION;
};
